// Label-only presentation: reuse the series' visible last value, formatter and
// projection. No extra price series, polling, data copies or autoscale range.
export class CurrentPriceLabelPrimitive {
  constructor(color) {
    this.color = color
    const rgb = color.slice(1).match(/../g).map(value => parseInt(value, 16))
    this.ink = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 160 ? '#000000' : '#FFFFFF'
    this.label = {
      coordinate: () => this.y ?? 0,
      text: () => this.valueText || '',
      textColor: () => this.ink,
      backColor: () => this.color,
      visible: () => this.y != null && Boolean(this.valueText),
      tickVisible: () => true,
    }
    this.views = [this.label]
  }
  attached({ series, requestUpdate }) {
    this.series = series
    requestUpdate()
  }
  detached() {
    this.series = null
    this.y = null
    this.valueText = ''
  }
  updateAllViews() {
    this.y = null
    this.valueText = ''
    if (!this.series || this.series.options().visible === false) return
    // Matches LWC's native last-value label when panning into older history.
    const last = this.series.lastValueData(false)
    if (last.noData || !Number.isFinite(last.price)) return
    const y = this.series.priceToCoordinate(last.price)
    if (y == null || !Number.isFinite(y)) return
    this.y = y
    this.valueText = this.series.priceFormatter().format(last.price)
  }
  priceAxisViews() { return this.views }
}
